// Umami vendor-specific payload rename.
//
// Umami Revenue API（https://docs.umami.is/docs/revenue）要求 conversion 事件以 `revenue`
// 帶金額（搭配 `currency`），與其他 tracker（GA4 / FB / TikTok / Kwai）使用 `value` 的
// 慣例不同。此處在 dispatcher 的 Umami 分支做 vendor-specific rename，callsite 維持
// `value`（其他 tracker 仍需要）。
//
// 同時剝除 `app_value`：該欄位設計上是給 App / Native Bridge 端用，Umami dashboard 無
// 對應語意，保留只會在 Events tab 出現冗餘欄位。
//
// 套用範圍刻意限縮在 conversion（purchase / first_deposit），不延伸到 `submit_deposit`
// 等 intent 事件 — submit_deposit 在 Umami 仍以 `value` 進 Events tab，與「真實營收」分流。

const UMAMI_REVENUE_EVENTS = new Set(['purchase', 'first_deposit'])

export default function applyUmamiVendorRename(eventName, payload, options = {}) {
  if (!UMAMI_REVENUE_EVENTS.has(eventName)) return payload
  const safe = payload || {}
  const { value, app_value: _appValue, ...rest } = safe
  // Umami Revenue API 要求 revenue 為數值並搭配 currency；任一缺失就 skip rename，
  // 避免送出 revenue: undefined 觸發 4xx 或產生金額為 0 的脫節事件
  if (value === undefined || value === null || !safe.currency) {
    if (options.isDev) {
      console.warn(`[umami] revenue rename skipped for "${eventName}": missing value or currency`, safe)
    }
    return rest
  }
  return { ...rest, revenue: value }
}

export { UMAMI_REVENUE_EVENTS }
